/**
 * kult-b2b-logo-upload.js — Custom Element <kult-b2b-logo-upload> (snippets/kult-b2b-logo-upload.liquid).
 * Eigener Logo-Upload für die Kult-Box (sections/kult-b2b-logo-box.liquid, Modus „Etikett-Service live testen“).
 * Datei wählen (Button, Input, Drag & Drop), Prüfung Typ/Größe, SVG über prepareSvg, Rastern auf höchstens 1000 px,
 * transparente Ränder beschneiden, Ergebnis als PNG-Data-URL, dominante Farbe für die Schleife.
 * Logik aus assets/kult-b2b-mischung.js übernommen (dort unverändert).
 *
 * Ereignis-Vertrag (document):
 *   sendet  "kult:b2b:logo" mit detail { url, color, name, scale, kaffee: '', data, source: 'upload', quality, qualityOk }
 *           url   = PNG-Data-URL zur Anzeige, leer ohne Logo
 *           data  = dieselbe PNG-Data-URL für den späteren Versand
 *           color = 'rgb(r, g, b)' oder leer; name = Originaldateiname; scale = Zahl (0,6 bis 1,25)
 *           quality = Druckqualität „druckfähig (w × h px)“ | „nur Vorschau (w × h px, Druckdatei folgt)“ |
 *                     „Vektordatei, druckfähig“ oder leer; qualityOk = true | false | null (unbekannt)
 *           (window.KultLogoQuality aus assets/kult-logo-quality.js, Mindestmaß Attribut data-min-px, Default 800)
 *           nach jedem Zustandswechsel (Logo gesetzt, Regler bewegt, entfernt)
 *   hört    "kult:b2b:logo-request" und sendet den aktuellen Stand erneut (auch den leeren)
 * Merken: sessionStorage "kult:b2b:logo" = { data, name, color, scale, src } (nur bis 2.000.000 Zeichen), Start stellt wieder her.
 *   src = { w, h, type } der Originaldatei für die Druckqualität (fehlt = unbekannt, keine Statuszeile).
 * Attribut data-msg-loaded setzt den Erfolgstext. Kein Framework, keine externen Skripte.
 */
(function () {
  'use strict';
  if (customElements.get('kult-b2b-logo-upload')) return;

  var STORE_KEY = 'kult:b2b:logo';
  var STORE_MAX = 2000000;
  var MAX_BYTES = 5 * 1024 * 1024;
  var MAX_SIDE = 1000;
  var TYPES = { 'image/png': 'png', 'image/svg+xml': 'svg', 'image/jpeg': 'jpg', 'image/jpg': 'jpg', 'image/pjpeg': 'jpg', 'image/webp': 'webp' };
  var EXT = { png: 'png', svg: 'svg', jpg: 'jpg', jpeg: 'jpg', webp: 'webp' };
  var MSG = {
    type: 'Diese Datei können wir nicht verwenden. Bitte wählen Sie ein Logo als PNG, SVG, JPG oder WebP.',
    size: 'Die Datei ist größer als 5 MB. Bitte wählen Sie eine kleinere Datei.',
    unreadable: 'Die Datei lässt sich nicht lesen. Bitte prüfen Sie sie oder wählen Sie eine andere.',
    loaded: 'Ihr Logo ist in der Vorschau. Es bleibt in Ihrem Browser, bis Sie Ihr Präsent in den Warenkorb legen.',
    removed: 'Logo entfernt.'
  };

  /* Dominierende Logo-Farbe (für die Schleife der Kult-Box): Auf ≤ 40.000 Pixel verkleinern; Pixel mit Deckkraft
     < 50 %, nahezu Weiß (alle Kanäle > 230) und Sichtbare zählen. Unbunt = Chroma < 38 oder HSL-Sättigung < 0,2;
     dunkle Unbunte (hellster Kanal < 110) werden gesammelt. Bunte Pixel in 18 Farbton-Klassen à 20° zählen,
     gewichtet mit der Sättigung; Gewinner = stärkstes Fenster aus Klasse und beiden Nachbarn (Rot über 0°/360°),
     Ergebnis = Mittelwert seiner Pixel. Stellt das bunte Fenster < 5 % der sichtbaren Pixel, gilt das Logo als unbunt:
     dann Mittelwert der dunklen Pixel, wenn sie ≥ 10 % der sichtbaren stellen, sonst ''. Fehler → ''. */
  function dominantColor(canvas) {
    try {
      var w = canvas.width, h = canvas.height;
      var f = Math.min(1, Math.sqrt(40000 / (w * h)));
      var sw = Math.max(1, Math.round(w * f)), sh = Math.max(1, Math.round(h * f));
      var c = document.createElement('canvas');
      c.width = sw; c.height = sh;
      var ctx = c.getContext('2d');
      ctx.drawImage(canvas, 0, 0, sw, sh);
      var d = ctx.getImageData(0, 0, sw, sh).data;
      var BINS = 18, bins = [], i, k;
      for (k = 0; k < BINS; k++) bins.push({ w: 0, n: 0, r: 0, g: 0, b: 0 });
      var visible = 0, dark = { n: 0, r: 0, g: 0, b: 0 };
      for (i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 128) continue;
        var r = d[i], g = d[i + 1], b = d[i + 2];
        var max = Math.max(r, g, b), min = Math.min(r, g, b), chroma = max - min;
        if (min > 230) continue;
        visible++;
        var sat = chroma / (255 - Math.abs(max + min - 255) || 1);
        if (chroma < 38 || sat < 0.2) {
          if (max < 110) { dark.n++; dark.r += r; dark.g += g; dark.b += b; }
          continue;
        }
        var hue;
        if (max === r) hue = ((g - b) / chroma + 6) % 6;
        else if (max === g) hue = (b - r) / chroma + 2;
        else hue = (r - g) / chroma + 4;
        var bin = bins[Math.min(BINS - 1, Math.floor(hue * 60 / 20))];
        bin.w += sat; bin.n++; bin.r += r; bin.g += g; bin.b += b;
      }
      if (!visible) return '';
      var best = -1, bestW = 0;
      for (k = 0; k < BINS; k++) {
        var win = bins[(k + BINS - 1) % BINS].w + bins[k].w + bins[(k + 1) % BINS].w;
        if (win > bestW) { bestW = win; best = k; }
      }
      if (best > -1) {
        var acc = { n: 0, r: 0, g: 0, b: 0 };
        [(best + BINS - 1) % BINS, best, (best + 1) % BINS].forEach(function (j) {
          acc.n += bins[j].n; acc.r += bins[j].r; acc.g += bins[j].g; acc.b += bins[j].b;
        });
        if (acc.n >= visible * 0.05) {
          return 'rgb(' + Math.round(acc.r / acc.n) + ', ' + Math.round(acc.g / acc.n) + ', ' + Math.round(acc.b / acc.n) + ')';
        }
      }
      if (dark.n >= visible * 0.1) {
        return 'rgb(' + Math.round(dark.r / dark.n) + ', ' + Math.round(dark.g / dark.n) + ', ' + Math.round(dark.b / dark.n) + ')';
      }
      return '';
    } catch (e) {
      return '';
    }
  }

  /* Ränder des Logos abschneiden, damit die sichtbare Marke die Logo-Fläche füllt (wie das Kult-Logo auf der Tüte).
     Transparente Ecken: nach Deckkraft; einfarbiger Hintergrund (z. B. Weiß bei JPG): nach Abstand zur Eckfarbe.
     Vollflächige Bilder (Foto, Logo ohne Rand) bleiben unverändert. */
  function trimCanvas(canvas) {
    var w = canvas.width, h = canvas.height, data;
    try { data = canvas.getContext('2d').getImageData(0, 0, w, h).data; } catch (e) { return canvas; }
    function px(x, y) { var i = (y * w + x) * 4; return [data[i], data[i + 1], data[i + 2], data[i + 3]]; }
    function dist(a, b) { return Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]); }
    var corners = [px(0, 0), px(w - 1, 0), px(0, h - 1), px(w - 1, h - 1)];
    var transparent = corners.every(function (c) { return c[3] < 24; });
    var bg = corners[0];
    var uniform = !transparent && corners.every(function (c) { return c[3] > 230 && dist(c, bg) < 30; });
    if (!transparent && !uniform) return canvas;
    var x0 = w, y0 = h, x1 = -1, y1 = -1, x, y, i, ink;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) {
        i = (y * w + x) * 4;
        ink = transparent ? data[i + 3] > 24 : (data[i + 3] > 24 && (Math.abs(data[i] - bg[0]) + Math.abs(data[i + 1] - bg[1]) + Math.abs(data[i + 2] - bg[2])) > 40);
        if (ink) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
    }
    if (x1 < 0) return canvas;
    var m = Math.round(Math.max(x1 - x0, y1 - y0) * 0.02);
    x0 = Math.max(0, x0 - m); y0 = Math.max(0, y0 - m); x1 = Math.min(w - 1, x1 + m); y1 = Math.min(h - 1, y1 + m);
    var cw = x1 - x0 + 1, ch = y1 - y0 + 1;
    if (cw >= w * 0.98 && ch >= h * 0.98) return canvas;
    var out = document.createElement('canvas');
    out.width = cw; out.height = ch;
    out.getContext('2d').drawImage(canvas, x0, y0, cw, ch, 0, 0, cw, ch);
    return out;
  }

  function loadImage(src, cors) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (cors) img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('image')); };
      img.src = src;
    });
  }

  /* SVG: Maße aus der viewBox ergänzen, damit Anzeige und Canvas in allen Browsern funktionieren */
  function prepareSvg(file) {
    return file.text().then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'image/svg+xml');
      var svg = doc.documentElement;
      if (!svg || svg.nodeName.toLowerCase() !== 'svg' || doc.getElementsByTagName('parsererror').length) throw new Error('svg');
      var vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(parseFloat);
      var hasVb = vb.length === 4 && vb[2] > 0 && vb[3] > 0;
      var w = parseFloat(svg.getAttribute('width')), h = parseFloat(svg.getAttribute('height'));
      var relative = /%/.test(svg.getAttribute('width') || '') || /%/.test(svg.getAttribute('height') || '');
      if (!(w > 0 && h > 0) || relative) {
        w = hasVb ? vb[2] : 300;
        h = hasVb ? vb[3] : 150;
        svg.setAttribute('width', String(w));
        svg.setAttribute('height', String(h));
      }
      var blob = new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' });
      return { url: URL.createObjectURL(blob), w: w, h: h };
    });
  }

  function formatName(name) { return String(name || ''); }

  class KultB2bLogoUploadEl extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;
      this.dropEl = this.querySelector('[data-logo-drop]');
      this.pickBtn = this.querySelector('[data-logo-pick]');
      this.fileInput = this.querySelector('[data-logo-file]');
      this.statusEl = this.querySelector('[data-logo-status]');
      this.loadedEl = this.querySelector('[data-logo-loaded]');
      this.nameEl = this.querySelector('[data-logo-name]');
      this.qualityEl = this.querySelector('[data-logo-quality]');
      this.qualityTextEl = this.querySelector('[data-logo-quality-text]');
      this.minPx = parseInt(this.getAttribute('data-min-px'), 10) || 800;
      this.src = null;
      this.quality = null;
      this.qualityTimer = 0;
      this.scaleInput = this.querySelector('[data-logo-scale]');
      this.scaleOut = this.querySelector('[data-logo-scale-out]');
      this.replaceBtn = this.querySelector('[data-logo-replace]');
      this.removeBtn = this.querySelector('[data-logo-remove]');
      this.data = '';
      this.name = '';
      this.color = '';
      this.scale = 1;
      this.loadToken = 0;
      this.msgLoaded = this.getAttribute('data-msg-loaded') || MSG.loaded;

      this.onPick = this.openPicker.bind(this);
      this.onFile = this.onFileChange.bind(this);
      this.onOver = this.onDragOver.bind(this);
      this.onLeave = this.onDragLeave.bind(this);
      this.onDropEv = this.onDrop.bind(this);
      this.onScaleEv = this.onScale.bind(this);
      this.onRemove = this.removeLogo.bind(this);
      this.onRequest = this.emitLogo.bind(this);

      if (this.pickBtn) this.pickBtn.addEventListener('click', this.onPick);
      if (this.replaceBtn) this.replaceBtn.addEventListener('click', this.onPick);
      if (this.fileInput) this.fileInput.addEventListener('change', this.onFile);
      if (this.dropEl) {
        this.dropEl.addEventListener('dragover', this.onOver);
        this.dropEl.addEventListener('dragleave', this.onLeave);
        this.dropEl.addEventListener('drop', this.onDropEv);
      }
      if (this.scaleInput) this.scaleInput.addEventListener('input', this.onScaleEv);
      if (this.removeBtn) this.removeBtn.addEventListener('click', this.onRemove);
      document.addEventListener('kult:b2b:logo-request', this.onRequest);

      this.paintScale();
      if (this.restore()) {
        this.paintLoaded();
        this.emitLogo();
      }
    }

    disconnectedCallback() {
      if (!this.__init) return;
      this.__init = false;
      this.loadToken++;
      window.clearTimeout(this.qualityTimer);
      if (this.pickBtn) this.pickBtn.removeEventListener('click', this.onPick);
      if (this.replaceBtn) this.replaceBtn.removeEventListener('click', this.onPick);
      if (this.fileInput) this.fileInput.removeEventListener('change', this.onFile);
      if (this.dropEl) {
        this.dropEl.removeEventListener('dragover', this.onOver);
        this.dropEl.removeEventListener('dragleave', this.onLeave);
        this.dropEl.removeEventListener('drop', this.onDropEv);
      }
      if (this.scaleInput) this.scaleInput.removeEventListener('input', this.onScaleEv);
      if (this.removeBtn) this.removeBtn.removeEventListener('click', this.onRemove);
      document.removeEventListener('kult:b2b:logo-request', this.onRequest);
    }

    openPicker() { if (this.fileInput) this.fileInput.click(); }

    onFileChange() {
      var file = this.fileInput.files && this.fileInput.files[0];
      this.handleFile(file);
      this.fileInput.value = '';
    }

    onDragOver(e) {
      if (!e.dataTransfer || Array.prototype.indexOf.call(e.dataTransfer.types || [], 'Files') === -1) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      this.dropEl.classList.add('is-dragover');
    }

    onDragLeave() { this.dropEl.classList.remove('is-dragover'); }

    onDrop(e) {
      e.preventDefault();
      this.dropEl.classList.remove('is-dragover');
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      this.handleFile(file);
    }

    setStatus(text, kind) {
      if (!this.statusEl) return;
      this.statusEl.textContent = text || '';
      this.statusEl.classList.toggle('kult-b2b-logo-upload__status--error', kind === 'error');
      this.statusEl.classList.toggle('kult-b2b-logo-upload__status--ok', kind === 'ok');
    }

    handleFile(file) {
      if (!file) return;
      var ext = (String(file.name || '').match(/\.([a-z0-9]+)$/i) || [])[1];
      var type = TYPES[file.type] || (ext ? EXT[ext.toLowerCase()] : '');
      if (!type) { this.setStatus(MSG.type, 'error'); return; }
      if (file.size > MAX_BYTES) { this.setStatus(MSG.size, 'error'); return; }
      this.setStatus('', '');
      var self = this;
      var token = ++this.loadToken;
      var source = type === 'svg' ? prepareSvg(file) : Promise.resolve({ url: URL.createObjectURL(file) });
      source.then(function (src) {
        return loadImage(src.url, false).then(function (img) { URL.revokeObjectURL(src.url); return { img: img, w: src.w, h: src.h }; }, function (err) { URL.revokeObjectURL(src.url); throw err; });
      }).then(function (res) {
        if (token !== self.loadToken) return;
        var w = res.img.naturalWidth || res.w, h = res.img.naturalHeight || res.h;
        if (!w || !h) throw new Error('size');
        if (!self.rasterize(res.img, w, h, type)) throw new Error('raster');
        self.name = file.name || 'logo.' + type;
        self.src = { w: Math.round(w), h: Math.round(h), type: type };
        self.paintLoaded();
        self.setStatus(self.msgLoaded, 'ok');
        self.persist();
        self.emitLogo();
      }).catch(function () {
        if (token === self.loadToken) self.setStatus(MSG.unreadable, 'error');
      });
    }

    rasterize(img, w, h, type) {
      try {
        var scale = type === 'svg' ? MAX_SIDE / Math.max(w, h) : Math.min(1, MAX_SIDE / Math.max(w, h));
        var canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(w * scale));
        canvas.height = Math.max(1, Math.round(h * scale));
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas = trimCanvas(canvas);
        this.data = canvas.toDataURL('image/png');
        this.color = dominantColor(canvas);
        return !!this.data;
      } catch (e) {
        this.data = '';
        this.color = '';
        return false;
      }
    }

    paintLoaded() {
      if (this.loadedEl) this.loadedEl.hidden = !this.data;
      if (this.nameEl) { this.nameEl.textContent = formatName(this.name); this.nameEl.title = formatName(this.name); }
      this.paintScale();
      this.paintQuality();
    }

    /* Druckqualität aus den Maßen der Originaldatei (this.src); Statuszeile unter dem Dateinamen, ok = Häkchen,
       low = Hinweis (kein Fehler). Text kommt kurz nach dem Einblenden, damit Screenreader die Live-Region kennen. */
    paintQuality() {
      var src = this.data ? this.src : null;
      this.quality = src && window.KultLogoQuality ? window.KultLogoQuality.check(src.w, src.h, src.type, this.minPx) : null;
      if (!this.qualityEl) return;
      var q = this.quality, el = this.qualityEl, textEl = this.qualityTextEl || el;
      window.clearTimeout(this.qualityTimer);
      textEl.textContent = '';
      el.removeAttribute('data-quality');
      if (!q) return;
      this.qualityTimer = window.setTimeout(function () {
        el.setAttribute('data-quality', q.kind === 'low' ? 'low' : 'ok');
        textEl.textContent = q.message;
      }, 150);
    }

    paintScale() {
      if (!this.scaleInput) return;
      var v = Math.round(this.scale * 100);
      var min = parseFloat(this.scaleInput.min) || 60, max = parseFloat(this.scaleInput.max) || 125;
      this.scaleInput.value = String(v);
      this.scaleInput.style.setProperty('--kult-range-fill', ((v - min) / (max - min)) * 100 + '%');
      this.scaleInput.setAttribute('aria-valuetext', v + ' Prozent');
      if (this.scaleOut) this.scaleOut.textContent = v + ' %';
    }

    onScale() {
      var min = parseFloat(this.scaleInput.min) || 60, max = parseFloat(this.scaleInput.max) || 125;
      var v = Math.min(max, Math.max(min, parseInt(this.scaleInput.value, 10) || 100));
      this.scale = v / 100;
      this.paintScale();
      this.persist();
      this.emitLogo();
    }

    removeLogo() {
      this.loadToken++;
      this.data = '';
      this.name = '';
      this.color = '';
      this.scale = 1;
      this.src = null;
      this.paintLoaded();
      this.setStatus(MSG.removed, '');
      try { window.sessionStorage.removeItem(STORE_KEY); } catch (e) { /* Speicher gesperrt */ }
      if (this.pickBtn) this.pickBtn.focus();
      this.emitLogo();
    }

    /* Zustand im Browser merken (nur Sitzung, nie auf dem Server) */
    persist() {
      try {
        if (!this.data) { window.sessionStorage.removeItem(STORE_KEY); return; }
        var json = JSON.stringify({ data: this.data, name: this.name, color: this.color, scale: this.scale, src: this.src });
        if (json.length > STORE_MAX) { window.sessionStorage.removeItem(STORE_KEY); return; }
        window.sessionStorage.setItem(STORE_KEY, json);
      } catch (e) { /* Speicher voll oder gesperrt */ }
    }

    restore() {
      try {
        var raw = window.sessionStorage.getItem(STORE_KEY);
        if (!raw) return false;
        var st = JSON.parse(raw);
        if (!st || typeof st.data !== 'string' || st.data.indexOf('data:image/png;base64,') !== 0) return false;
        this.data = st.data;
        this.name = typeof st.name === 'string' ? st.name : '';
        this.color = typeof st.color === 'string' ? st.color : '';
        var sc = parseFloat(st.scale);
        this.scale = isFinite(sc) && sc >= 0.6 && sc <= 1.25 ? sc : 1;
        var src = st.src && typeof st.src === 'object' ? st.src : null;
        var types = { svg: 1, png: 1, jpg: 1, webp: 1 };
        this.src = src && types[src.type] && (src.type === 'svg' || (src.w > 0 && src.h > 0)) ? { w: Math.round(src.w) || 0, h: Math.round(src.h) || 0, type: src.type } : null;
        return true;
      } catch (e) {
        return false;
      }
    }

    emitLogo() {
      document.dispatchEvent(new CustomEvent('kult:b2b:logo', { detail: {
        url: this.data || '',
        color: this.color || '',
        name: this.name || '',
        scale: this.scale || 1,
        kaffee: '',
        data: this.data || '',
        source: 'upload',
        quality: this.data && this.quality ? this.quality.value : '',
        qualityOk: this.data && this.quality ? this.quality.ok : null
      } }));
    }
  }

  customElements.define('kult-b2b-logo-upload', KultB2bLogoUploadEl);
})();
